module.exports = __webpack_public_path__ + "img/RegPic1.dae1dc98.png";